'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _capitalize = require('../../utils/capitalize');

var _capitalize2 = _interopRequireDefault(_capitalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getLunaWidth = function getLunaWidth(width) {
    switch (width) {
        case '12/12':
        case '1/1':
            return '1/1';
        case '9/12':
        case '3/4':
            return '3/4';
        case '8/12':
        case '2/3':
            return '2/3';
        case '6/12':
        case '1/2':
            return '1/2';
        case '4/12':
        case '2/6':
        case '1/3':
            return '1/3';
        case '3/12':
            return '1/4';
        case '2/12':
            return '1/6';
        default:
            return width;
    }
};
var Column = function Column(_ref) {
    var _classnames;

    var className = _ref.className,
        align = _ref.align,
        width = _ref.width,
        s = _ref.s,
        m = _ref.m,
        l = _ref.l,
        first = _ref.first,
        last = _ref.last,
        sFirst = _ref.sFirst,
        sLast = _ref.sLast,
        mFirst = _ref.mFirst,
        mLast = _ref.mLast,
        lFirst = _ref.lFirst,
        lLast = _ref.lLast,
        children = _ref.children,
        show = _ref.show,
        sShow = _ref.sShow,
        mShow = _ref.mShow,
        lShow = _ref.lShow,
        hide = _ref.hide,
        sHide = _ref.sHide,
        mHide = _ref.mHide,
        lHide = _ref.lHide;

    var columnClassNames = (0, _classnames3.default)('u-grid__col', className, (_classnames = {}, _defineProperty(_classnames, 'u-grid__col--align' + (0, _capitalize2.default)(align), align), _defineProperty(_classnames, 'u-' + getLunaWidth(width), getLunaWidth(width)), _defineProperty(_classnames, 'u-' + getLunaWidth(s) + '@s', getLunaWidth(s)), _defineProperty(_classnames, 'u-' + getLunaWidth(m) + '@m', getLunaWidth(m)), _defineProperty(_classnames, 'u-' + getLunaWidth(l) + '@l', getLunaWidth(l)), _defineProperty(_classnames, 'u-grid__col--orderFirst', first), _defineProperty(_classnames, 'u-grid__col--orderLast', last), _defineProperty(_classnames, 'u-grid__col--orderFirst@s', sFirst), _defineProperty(_classnames, 'u-grid__col--orderLast@s', sLast), _defineProperty(_classnames, 'u-grid__col--orderFirst@m', mFirst), _defineProperty(_classnames, 'u-grid__col--orderLast@m', mLast), _defineProperty(_classnames, 'u-grid__col--orderFirst@l', lFirst), _defineProperty(_classnames, 'u-grid__col--orderLast@l', lLast), _defineProperty(_classnames, 'is-visible', show), _defineProperty(_classnames, 'is-visible@s', sShow), _defineProperty(_classnames, 'is-visible@m', mShow), _defineProperty(_classnames, 'is-visible@l', lShow), _defineProperty(_classnames, 'is-hidden', hide), _defineProperty(_classnames, 'is-hidden@s', sHide), _defineProperty(_classnames, 'is-hidden@m', mHide), _defineProperty(_classnames, 'is-hidden@l', lHide), _classnames));
    return _react2.default.createElement("div", { className: columnClassNames }, children);
};
var ALIGN_VALUES = ['top', 'middle', 'bottom'];
var WIDTH_VALUES = ['1/12', '2/12', '3/12', '4/12', '5/12', '6/12', '7/12', '8/12', '9/12', '10/12', '11/12', '12/12', '1/1', '1/2', '1/3', '1/4', '1/5', '1/6', '2/3', '3/4', '4/5', '2/5', '3/5', ''];
Column.propTypes = {
    align: _propTypes2.default.oneOf(ALIGN_VALUES),
    width: _propTypes2.default.oneOf(WIDTH_VALUES),
    s: _propTypes2.default.oneOf(WIDTH_VALUES),
    m: _propTypes2.default.oneOf(WIDTH_VALUES),
    l: _propTypes2.default.oneOf(WIDTH_VALUES),
    first: _propTypes2.default.bool,
    last: _propTypes2.default.bool,
    sFirst: _propTypes2.default.bool,
    sLast: _propTypes2.default.bool,
    mFirst: _propTypes2.default.bool,
    mLast: _propTypes2.default.bool,
    lFirst: _propTypes2.default.bool,
    lLast: _propTypes2.default.bool
};
exports.default = Column;
//# sourceMappingURL=Column.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Grid/Column.js